import { X } from "lucide-react"
import { Input } from "../../components/ui/input"

export type SortBy =
  | "name"
  | "price_asc"
  | "price_desc"
  | "duration_asc"
  | "duration_desc"
  | "points_asc"
  | "points_desc"

export type ServicesFiltersProps = {
  searchTerm: string
  onSearchTermChange: (val: string) => void
}

export const ServicesFilters = ({
  searchTerm,
  onSearchTermChange,
}: ServicesFiltersProps) => {
  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div className="relative md:min-w-[360px] flex-1">
        <Input
          placeholder="Rechercher un service..."
          value={searchTerm}
          onChange={(e) => onSearchTermChange(e.target.value)}
          className="pl-10 pr-9"
          aria-label="Rechercher un service"
        />
        {searchTerm && (
          <button
            aria-label="Effacer la recherche"
            className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
            onClick={() => onSearchTermChange("")}
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  )
}

export default ServicesFilters
